import { Flex, Image, Stack, Text } from '@chakra-ui/react';

import Banner3D from 'src/img/3D-new-customer-banner.png';
import BannerGradient from 'src/img/3D-gradient-new-customer-banner.png';

export const NewCustomerBanner = () => (
  <Flex
    backgroundColor="#F7F9FC"
    padding="16px"
    paddingLeft={{
      base: '60px',
      md: '120px',
    }}
    paddingRight={{
      base: '58px',
      md: '130px',
    }}
    alignItems="center"
    borderRadius="8px"
    overflow="hidden"
    position="relative"
    marginBottom="27px"
  >
    <Image
      src={Banner3D}
      alt="Novo cliente 3D"
      position="absolute"
      width={{
        base: '60px',
        md: 'auto',
      }}
      left={{
        base: '-16px',
        md: '5px',
      }}
      top="50%"
      transform="translateY(-50%)"
    />
    <Stack spacing="4px">
      <Text fontWeight="bold" color="#373D43" lineHeight="24px" fontSize="xl">
        Cliente novo 🎉
      </Text>
      <Text lineHeight="21px" color="#777A7C" fontWeight="400" fontSize="md">
        Este é o primeiro pedido que você está recebendo deste cliente!
      </Text>
    </Stack>
    <Image
      src={BannerGradient}
      alt="Novo cliente 3D"
      position="absolute"
      width={{
        base: '91px',
        md: 'auto',
      }}
      right="-1px"
      top="50%"
      transform="translateY(-50%)"
    />
  </Flex>
);
